<template>
    <component
        :is="rootTag"
        class="btn"
        :class="buttonClasses"
        :type="to || href ? undefined : type"
        :disabled="to || href ? undefined : disabled || loading || undefined"
        :to="to"
        :href="href || undefined"
        :target="href ? '_blank' : undefined"
        :rel="href ? 'noopener noreferrer' : undefined"
        :aria-busy="loading || undefined"
    >
        <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        <i v-else-if="icon" :class="icon" aria-hidden="true"></i>
        <slot></slot>
    </component>
</template>

<script setup lang="ts">
import { computed, useSlots } from "vue";
import { RouterLink, type RouteLocationRaw } from "vue-router";

defineOptions({ name: "UiButton" });

export type UiButtonVariant = "primary" | "secondary" | "danger" | "warning" | "login";
export type UiButtonSize = "md" | "sm" | "xs";

const {
    variant = "primary",
    size = "md",
    type = "button",
    disabled = false,
    loading = false,
    icon = "",
    to = undefined,
    href = "",
} = defineProps<{
    variant?: UiButtonVariant;
    size?: UiButtonSize;
    type?: "button" | "submit";
    disabled?: boolean;
    loading?: boolean;
    icon?: string;
    to?: RouteLocationRaw;
    href?: string;
}>();

const slots = useSlots();

const rootTag = computed(() => {
    if (to) {
        return RouterLink;
    }
    if (href) {
        return "a";
    }
    return "button";
});

const buttonClasses = computed(() => {
    return {
        [`btn-${variant}`]: true,
        [`btn-${size}`]: size !== "md",
        "btn-icon-only": !!icon && !slots.default,
    };
});
</script>
